import {useWelcomeAssistantContext} from "./ContextType";
import React from "react";

export function WelcomeAssistantStages({children}: any) {
    const {currentStage} = useWelcomeAssistantContext();

    return (
        <>
            {React.Children.toArray(children)[currentStage - 1]}
        </>
    );
}